import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import Details from '../Details/Details'

import { getOngoingQuotes } from '../../../actions/quote'

import './Ongoing.css'
import { KeyboardArrowDown } from '@material-ui/icons'

const Ongoing = () => {
    dayjs.extend(relativeTime)
    const dispatch = useDispatch()
    const quotes = useSelector(state => state.quotes.ongoing)
    const [quote, setQuote] = useState({})
    const [loading, setLoading] = useState(true)
    const [skip, setSkip] = useState(0)
    const [showDetails, setShowDetails] = useState(false)

    const getQuotes = useCallback(() => {
        dispatch(getOngoingQuotes({ status: { status: "ongoing" }, skip: 0 }, setLoading))
    }, [dispatch])

    const handleNextPage = async () => {
        dispatch(getOngoingQuotes({ status: { status: "ongoing" }, skip: (skip + 20 )}, setLoading))

        setSkip(skip => skip + 20)
    }

    const handleDetails = (quote) => {
        setQuote(quote)
        setShowDetails(true)
    }

    useEffect(() => {
        if(quotes.length === 0) getQuotes()
        else setLoading(false)
    }, [getQuotes, quotes])

    return (
        <>
        {showDetails && <Details quote={quote} showDetails={showDetails} setShowDetails={setShowDetails} ongoing/>}
        <div className="pending">
            <h2 className="mb-40 py-20 font-subhead">
                ONGOING PROJECTS
                <span style={{background: 'rgb(223, 255, 223)', color: 'green'}} className="admin__project__counter text-center font-bigger px-40 ml-20 curved-20">{quotes.length}</span>
            </h2>
            <div className="admin__scroll__ctn">
                <div className="admin__scroll__1024 d-flex w-100 mb-40">
                    <span className="admin__serial font-bold">S/N</span>
                    <div className="grid c-6 w-90 px-10">
                        <span className="font-bold">Project Name</span>
                        <span className="font-bold">Translation</span>
                        <span className="font-bold">Review Date</span>
                        <span className="font-bold">Delivey Date</span>
                        <span className="font-bold">Quantity</span>
                    </div>
                </div>
                {loading ?
                    <div className="loader mx-auto">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                        :
                    <>
                    {quotes.length < 1 && <div className="font-bolder font-bigger text-center">No ongoing project</div>} 
                    {quotes.map((quote, index) =>
                        <div className="admin__projects admin__scroll__1024 d-flex align-center pointer mb-20" key={quote.projectName.concat(index)}>
                            <span className="admin__serial font-bold">{index + 1}</span>
                            <div className="position-relative grid align-center c-6 w-90 p-10 my-10 rounded box-shadow-lg">
                                <span title={quote.projectName} className="ellipsis pr-10">{quote.projectName}</span>
                                <span title={`${quote.languageFrom} to ${quote.languageTo.map(lang => lang).join(', ')}`} className="text-uppercase ellipsis pr-10">
                                    {(quote.languageFrom).substring(0, 2)}-{quote.languageTo.map(lang => lang.substring(0, 2)).join(',')}
                                </span>
                                <span title={dayjs(quote.reviewDate).format("dddd, MMMM D YYYY")}>{dayjs(quote.reviewDate).fromNow()}</span>
                                <span title={dayjs(quote.deliveryDate).format("dddd, MMMM D YYYY")}>{dayjs(quote.deliveryDate).fromNow()}</span>
                                <span title={dayjs(quote.deliveryDate).format("dddd, MMMM D YYYY")}>
                                    {quote.totalPages ? `${quote.totalPages} page${quote.totalPages > 1 ? 's' : ''}` : `${quote.totalCount} words`}
                                </span>
                                <div className="d-flex justify-center">
                                    <button className="border-0 outline-0 w-75 font-bold rounded" onClick={() => handleDetails(quote)}>
                                        Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    </>
                }
                {(!loading && quotes > 19) &&
                    <div className="d-flex justify-center p-20 pointer" onClick={handleNextPage}>
                        <div className="d-flex align-center border-1 px-20 py-5 curved-20">
                            <span className="font-bold">View More</span>
                            <KeyboardArrowDown className="ml-5" fontSize="large" />
                        </div>
                    </div>
                }
            </div>
        </div>
        </>
    )
}

export default Ongoing
